import React, { createContext, useContext, useState, useEffect } from 'react';

const DarkModeContext = createContext();

export function useDarkMode() {
  return useContext(DarkModeContext);
}

export function DarkModeProvider({ children }) {
  const [darkMode, setDarkMode] = useState(() => {
    // Lade aus localStorage
    const saved = localStorage.getItem('darkMode');
    return saved === 'true';
  });

  useEffect(() => {
    // Speichere in localStorage
    localStorage.setItem('darkMode', darkMode);
    
    // Setze CSS Klasse am body
    // color-scheme am Wurzelelement: "only light" verhindert, dass Chrome auf
    // Android die helle Seite eigenmächtig abdunkelt (Auto Dark Theme) – der
    // Nutzer hat hier seinen eigenen Schalter. theme-color färbt die Browserleiste.
    document.documentElement.style.colorScheme = darkMode ? 'dark' : 'only light';
    const meta = document.querySelector('meta[name="theme-color"]');
    if (meta) meta.setAttribute('content', darkMode ? '#1a1a1a' : '#ffffff');
    if (darkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [darkMode]);

  const toggleDarkMode = () => {
    setDarkMode(prev => !prev);
  };

  const value = {
    darkMode,
    toggleDarkMode
  };

  return (
    <DarkModeContext.Provider value={value}>
      {children}
    </DarkModeContext.Provider>
  );
}